module.exports = __webpack_public_path__ + "img/gbx.a4bba686.svg";